import React, { useState } from "react";
import { ReactComponent as QAIcon } from "assets/icons/QA.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/Settings.svg";
import { ReactComponent as BookIcon } from "assets/icons/Book.svg";
import { ReactComponent as UserIcon } from "assets/icons/User.svg";
import { ReactComponent as OverviewIcon } from "assets/icons/Overview.svg";
import { ReactComponent as FluentIcon } from "assets/icons/Fluent.svg";
import { ReactComponent as EyeIcon } from "assets/icons/Eye.svg";
import { ReactComponent as LibraryIcon } from "assets/icons/Library.svg";
import { ReactComponent as FileIcon } from "assets/icons/File.svg";
import { Link, useLocation } from "react-router-dom";
import "primeicons/primeicons.css";

export default function Sidebar() {
  const location = useLocation();
  const activeLink = location?.pathname

  return (
    <div className="dashboard-sidebar transition-duration-300 transition-all flex absolute md:sticky z-5 md:top-0 flex-column w-full max-w-18rem xl:max-w-20rem h-screen p-2 text-base lg:text-lg font-bold line-height-3 karla border-right-2 surface-border white-bg color-sidebar">
      <div className="flex flex-column gap-2 p-1">
        <Link
          to="/"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/dashboard" ? "active" : ""
            }`}
        >
          <OverviewIcon className="mr-3 xl:mr-4" />
          Overview
        </Link>
        <Link
          to="/project-management"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/project-management" ? "active" : ""
            }`}
        >
          <FileIcon className="mr-3 xl:mr-4" />
          Project Management
        </Link>
        <Link
          to="/contract-generator"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/contract-generator" ? "active" : ""
            }`}
        >
          <FluentIcon className="mr-3 xl:mr-4" />
          Contract Generator
        </Link>
        <Link
          to="/contract-review"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/contract-review" ? "active" : ""
            }`}
        >
          <EyeIcon className="mr-3 xl:mr-4" />
          Contract Review
        </Link>
        <Link
          to="/agreement"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/agreement" ? "active" : ""
            }`}
        >
          <LibraryIcon className="mr-3 xl:mr-4" />
          Agreement Library
        </Link>
        <Link
          // to="/qa"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/qa" ? "active" : ""
            }`}
        >
          <QAIcon className="mr-3 xl:mr-4" />
          Q&A
        </Link>
        <Link
          // to="/consult"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/consult" ? "active" : ""
            }`}
        >
          <BookIcon className="mr-3 xl:mr-4" />
          Book a Consultant
        </Link>
        <Link
          to="/profile"
          className={`color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/profile" ? "active" : ""
            }`}
        >
          <UserIcon className="mr-3 xl:mr-4" />
          My Profile
        </Link>
        <Link
          // to="/settings"
          className={` flex align-items-center color-sidebar hover:cream-bg px-3 lg:px-4 py-2 lg:py-3 border-round ${activeLink === "/setting" ? "active" : ""
            }`}
        >
          <SettingsIcon className="mr-3 lg:mr-3" />
          Settings
        </Link>
      </div>
    </div>
  );
}
